export enum OrderExecutionTermsOrderType {
  /** Рыночный */
  Market = 'Market',
  /** Лимитный */
  Limit = 'Limit',
}

export enum OrderExecutionTermsOperationKind {
  /** Передача прав на ценные бумаги с переводом денег */
  DeliveryVersusPayment = 'DeliveryVersusPayment',
  /** Передача прав на ценные бумаги без перевода денег */
  DeliveryFreeOfPayment = 'DeliveryFreeOfPayment',
  /** Смена номинального держателя */
  ChangeNominalHolder = 'ChangeNominalHolder',
  /** Обмен ценными бумагами. */
  Exchange = 'Exchange',
}

/** Условия исполнения */
export interface OrderExecutionTermsEntity {
  /** Дополнительные заметки */
  additionalNotes?: string;

  /** Тип заказа */
  orderType?: OrderExecutionTermsOrderType;

  /** Доходность */
  yield?: string;

  /** Вид операции */
  operationKind?: OrderExecutionTermsOperationKind;

  /** Цель операции */
  operationPurpose?: string;
}
